import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/bankService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";

class BankForm extends Form {
  state = {
    data: {
      name: "",
      address: "",
      phone: "",
      account: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    name: Joi.string().required().label("Visa Account"),
    address: Joi.string().required().label("Address"),
    phone: Joi.string().required().label("Phone"),
    account: Joi.string().required().label("Account"),
    account_title: Joi.string().required().label("Account Title"),
    iban: Joi.string().required().label("IBAN"),
    branch_name: Joi.string().required().label("Branch Name"),
    branch_code: Joi.string().required().label("Branch Code"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      await saveSingle(this.state.data);
      toast.success("Account has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/banks-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.account)
          errors.account = ex.response.data.errors.account;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add bank acount</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/banks-accounts")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add bank acount</h3>
              <p>Provide the information below to add the bank account.</p>
              {this.renderInput("name", "Bank Name", "text")}
              {this.renderInput("address", "Address", "text")}
              {this.renderInput("phone", "Phone", "text")}
              {this.renderInput("account", "Account Number", "text")}
              {this.renderInput("account_title", "Account Title", "text")}
              {this.renderInput("iban", "IBAN", "text")}
              {this.renderInput("branch_name", "Branch Name", "text")}
              {this.renderInput("branch_code", "Branch Code", "text")}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default BankForm;
